import { Component, Input } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-mat-spinner-container',
    templateUrl: './mat-spinner-container.component.html',
    styleUrls: ['./mat-spinner-container.component.scss'],
    standalone: false,
})
export class MatSpinnerContainerComponent {
    @Input() width = 0;
    @Input() height = 0;
    @Input() diameter = 0;
    @Input() strokeWidth = 0;
    @Input() margin = '0';
    @Input() mode: ProgressSpinnerMode = 'indeterminate';
}
